var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAnswer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-answer_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F46790",
  d: "M8 1c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-1C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.707 11.433a.7.7 0 0 1-.707.706.695.695 0 0 1-.707-.706c0-.4.307-.694.707-.694s.707.3.707.694m-.12-7.06-.127 5.04c-.013.34-.227.46-.46.46s-.447-.12-.447-.46l-.14-5.04c0-.36.234-.514.587-.514s.6.147.587.514"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-answer_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgIcAnswer;